export default "__VITE_ASSET__BrdHSaM6__"